import { useState } from 'react';
import { Analytics, useRiskRemidiationTrendAnalyticsQuery } from '@/__generated__/graphql';
import { RISK_REMEDIATION_TREND } from '@/constants';
import { useSetAtom } from 'jotai';
import * as state from '@/state';

export const useRiskRemediationData = (structureIds: string[]) => {
  const setHasRiskRemediationData = useSetAtom(state.hasRiskRemediationData);
  const combineDataByMonthAndYear = (analyticsData: Analytics['data'][]) => {
    if (!analyticsData || analyticsData.length === 0) return [];
    const metricsConfig = analyticsData[0].displayConfig.metrics;
    const metricsKeys = Object.keys(metricsConfig);
    const combinedDataMap = new Map();
    analyticsData.map((analytics: Analytics['data']) => {
      if (!analytics?.data) return;
      analytics.data
        .sort(
          (a: Analytics['data'][number], b: Analytics['data'][number]) =>
            new Date(a.monthData).getTime() - new Date(b.monthData).getTime()
        )
        .map((item: Analytics['data'][number]) => {
          const monthDataKey = item.monthData;
          if (!combinedDataMap.has(monthDataKey)) {
            const newItem: Analytics['data'][number] = {
              month: item.month,
              year: item.year,
              monthData: item.monthData,
            };
            metricsKeys.map((key) => {
              const value = item[key] || 0;
              const decimals = metricsConfig[key]?.decimals;
              newItem[key] = decimals !== undefined ? Number(value.toFixed(decimals)) : value;
            });
            combinedDataMap.set(monthDataKey, newItem);
          } else {
            const existing = combinedDataMap.get(monthDataKey);
            metricsKeys.map((key) => {
              const newValue = existing[key] + (item[key] || 0);
              const decimals = metricsConfig[key]?.decimals;
              existing[key] =
                decimals !== undefined ? Number(newValue.toFixed(decimals)) : newValue;
            });
          }
        });
    });

    const result = [...combinedDataMap.values()];

    return result.map((item, index) => ({
      ...item,
      index,
    }));
  };
  const [remediationData, setRemediationData] = useState<Analytics['data']>([]);
  const [displayConfig, setDisplayConfig] = useState<Analytics['displayConfig']>({});
  const { loading, error } = useRiskRemidiationTrendAnalyticsQuery({
    variables: {
      input: {
        structureIds,
        type: [RISK_REMEDIATION_TREND],
      },
    },
    onCompleted: (data) => {
      if (!data?.analytics || data.analytics.length === 0) {
        setRemediationData([]);
        setDisplayConfig({});
        return;
      }
      const combinedData = combineDataByMonthAndYear(data.analytics);
      setRemediationData(combinedData);
      setDisplayConfig(data.analytics[0]?.displayConfig || {});
      setHasRiskRemediationData(true);
    },
  });

  return {
    data: remediationData,
    displayConfig,
    loading,
    error,
  };
};
